module.exports = new __parcel__URL__("select-azure-csv.cd81e6e5.svg").toString();